import { motion } from "framer-motion";
import { Target, Lightbulb, FolderOpen } from "@phosphor-icons/react";

const UPDATES = [
  {
    id: "personalized",
    title: "Personalized to your unit",
    icon: <Target size={22} weight="duotone" />,
    body: "A 30-second setup asks what you work and what you reach for most. Stable-ish pins your top tools right where you need them, so the thing you use ten times a shift isn't buried three taps deep.",
  },
  {
    id: "nudges",
    title: "Smart tool nudges",
    icon: <Lightbulb size={22} weight="duotone" />,
    body: "Ask something a calculator or cheatsheet answers faster, and Stable-ish surfaces the right one above the answer. Covers all 50+ tools and cheatsheets.",
  },
  {
    id: "protocols",
    title: "My Protocols",
    icon: <FolderOpen size={22} weight="duotone" />,
    body: "Upload your own hospital policies and ask questions against them. Answers cite the policy they came from, so you know whether it's your facility's rule or general reference.",
  },
];

export default function WhatsNew() {
  return (
    <section
      id="whats-new"
      data-testid="whats-new-section"
      className="relative bg-[#070707] border-t border-white/10 noise scroll-mt-20"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-24 md:py-32">
        {/* Header */}
        <div className="max-w-3xl">
          <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#FF2A2A] mb-5">
            § 01 · what&rsquo;s new in v1.1.5
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl xl:text-[72px] font-extrabold tracking-tighter leading-[0.95]">
            Fresh in{" "}
            <span className="italic font-light text-white/70">v1.1.5.</span>
          </h2>
          <p className="mt-6 text-base md:text-lg text-white/65 max-w-2xl leading-relaxed">
            Smarter suggestions, a setup that actually knows your unit, and a
            tighter app under the hood.
          </p>
        </div>

        {/* Feature cards */}
        <div
          className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-4"
          data-testid="whats-new-grid"
        >
          {UPDATES.map((item, i) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="group border border-white/10 hover:border-[#FF2A2A]/50 bg-[#0a0a0a] p-7 transition-colors"
              data-testid={`whats-new-card-${item.id}`}
            >
              <div className="w-11 h-11 shrink-0 flex items-center justify-center border border-[#FF2A2A]/30 bg-[#FF2A2A]/[0.06] text-[#FF2A2A] group-hover:bg-[#FF2A2A]/10 transition-colors mb-5">
                {item.icon}
              </div>
              <h3 className="font-display text-xl sm:text-2xl font-extrabold tracking-tight text-white leading-tight">
                {item.title}
              </h3>
              <p className="mt-3 text-sm md:text-base text-white/60 leading-relaxed">
                {item.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
